import React from "react";
import PropTypes from "prop-types";
import validate from "validate.js";

/**
 * Componente que corresponde a un input básico.
 *
 * @param {*} props
 * @param {string} name nombre del input
 * @param {string} [styleName] class adicional del input. Default undefined.
 * @param {string} [type] tipo de input. Default `text`.
 * @param {function}[handleChange] handler del evento change. Default `undefined`.
 * @param {string|number|boolean} [value] valor por defecto del input. Default null.
 */

export default class Switch extends React.Component {
  /**
   * @constructor
   *
   * @param {*} props
   * @param {string} name nombre del input
   * @param {string} [styleName] class adicional del input. Default undefined.
   * @param {string} [placeholder] placeholder del input. Default undefined.
   * @param {string} [type] tipo de input. Default `text`.
   * @param {function}[handleChange] handler del evento change. Default `undefined`.
   * @param {string|number|boolean} [value] valor por defecto del input. Default null.
   */
  constructor(props) {
    super(props);

    this.state = { value: this.props.value };
    this.handleChange = this.handleChange.bind(this);
    this.renderFeedback = this.renderFeedback.bind(this);
    this.getClassName = this.getClassName.bind(this);
    this.renderInput = this.renderInput.bind(this);
    this.renderValue = this.renderValue.bind(this);
  }

  /**
   * Cuando el componente se monta se setea el valor.
   */
  componentDidMount() {
    let rnd = Math.round(Math.random() * 10000);
    this._id = "form-input-" + rnd + "-" + new Date().getTime();
  }

  validate(value) {
    let feedback = null;
    if (this.props.validations) {
      let d = { val: value };
      let constraints = { val: this.props.validations };
      let result = validate(d, constraints);
      feedback = result ? result.val[0].replace("Val ", "") : undefined;
    }
    return feedback;
  }
  /**
   * Handler del evento change del input.
   * @param {*} event
   */
  handleChange(event) {
    const target = event.target;
    let value = target.checked;
    let feedback = null;
    feedback = this.validate(value);

    // si existe la función handler de, se dispara la invocación.
    if (typeof this.props.handleChange !== "undefined") {
      this.props.handleChange(value);
    }

    //se seta el valor del input.
    this.setState({
      value: value,
      feedback: feedback
    });
  }

  onBlurChange(value) {
    let feedback = this.validate(value);
    this.setState({
      feedback: feedback
    });
  }

  /**
   * Se encarga de renderizar el feedback de validación.
   */
  renderFeedback() {
    const hasFeedback =
      this.state.feedback && this.state.feedback.length > 0 ? true : false;
    return (
      <div>
        {hasFeedback && (
          <small className="invalid-feedback">{this.state.feedback}</small>
        )}
        {!hasFeedback && (
          <p className="form-text text-muted">{this.props.help}</p>
        )}
      </div>
    );
  }
  /**
   * Si el input es obligatorio retorna true, en caso contrario retorna false.
   */
  isRequired() {
    return this.props.validations && this.props.validations.presence;
  }
  /**
   * Se encarga de recurmerar el classname teniendo en cuenta si el input
   * requiere o no validación.
   */
  getClassName() {
    let clazz = this.props.styleName;
    if (this.isRequired() && this.state.feedback) {
      clazz += " is-invalid";
    } else if (this.isRequired) {
      clazz += " is-valid";
    }
    return clazz;
  }

  /**
   * Se encarga de renderizar el input.
   */

  renderInput() {
    return (
      <input
        type={this.props.type}
        name={this.props.name}
        required={this.isRequired()}
        onChange={this.handleChange}
        checked={this.props.value}
      />
    );
  }

  renderValue() {
    return this.state.value ? "Sí" : "No";
  }
  /**
   * Se encarga de renderizar el componente
   */
  render() {
    let clazz = this.props.validations ? "was-validated" : "";
    return (
      <div>
        <label className="form-check-label">
          <label className="switch">
            {this.renderInput()}
            <div className="slider round" />
          </label>
          &nbsp;
          {this.props.placeholder}
        </label>
        {this.renderFeedback()}
      </div>
    );
  }
}

/**
 * @param {*} props
 * @param {string} name nombre del input
 * @param {string} [styleName] class adicional del input. Default undefined.
 * @param {string} [placeholder] placeholder del input. Default undefined.
 * @param {string} [type] tipo de input. Default `text`.
 * @param {function}[handleChange] handler del evento change. Default `undefined`.
 * @param {string|number|boolean} [value] valor por defecto del input. Default null.
 */
Switch.propTypes = {
  name: PropTypes.string,
  styleName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.bool,
  validations: PropTypes.object
};

Switch.defaultProps = {
  styleName: "checkbox",
  type: "checkbox",
  value: false
};
